module.exports = __webpack_public_path__ + "static/media/c02-01-7.8abc6efa.png";